<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.60127 16.6667C7.27586 16.9922 6.74819 16.9922 6.42277 16.6667C6.09736 16.3413 6.09736 15.8137 6.42277 15.4882L11.3217 10.5893C11.6471 10.2639 11.6471 9.73625 11.3217 9.41083L6.42277 4.51192C6.09736 4.1865 6.09736 3.65883 6.42277 3.33342C6.74819 3.008 7.27586 3.008 7.60127 3.33342L13.6787 9.41083C14.0041 9.73625 14.0041 10.2639 13.6787 10.5893L7.60127 16.6667Z"
      fill="#153D49"
    />
  </svg>
</template>
